import { render } from "./ItemTable.vue?vue&type=template&id=be5bd85e&scoped=true"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"

import "./ItemTable.vue?vue&type=style&index=0&id=be5bd85e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5bd85e"]])

export default __exports__